// @ts-nocheck

// App
import React from 'react';
import { useYieldCallback } from '@zillow/yield-callback';

// Misc / utils
import PATHS_MANIFEST from 'app/shared/utils/pathsManifest';
import * as S from './styles';

const FooterLinks = ({ onLinkClick, onModalLinkClick }) => {
  const handleCookiePreferencesClick = useYieldCallback(() => {
    if (typeof window !== 'undefined' && window.DG_BANNER_API) {
      window.DG_BANNER_API.showLayer('categories-layer');
    }
  });

  return (
    <S.FooterList>
      <S.Li>
        <S.Linker
          linkType="inverted"
          to={PATHS_MANIFEST.ApartmentsNearMePage}
          tabIndex={0}
          onClick={(e) => onLinkClick(e, { path: PATHS_MANIFEST.ApartmentsNearMePage })}
          data-footer-page={'apartmentsNearMePage'}
        >
          Apartments near me
        </S.Linker>
      </S.Li>
      <S.Li>
        <S.Linker
          linkType="inverted"
          to={PATHS_MANIFEST.HousesNearMe}
          tabIndex={0}
          onClick={(e) => onLinkClick(e, { path: PATHS_MANIFEST.HousesNearMe })}
          data-footer-page={'housesNearMePage'}
        >
          Houses near me
        </S.Linker>
      </S.Li>
      <S.Li>
        <S.Linker
          linkType="inverted"
          to={PATHS_MANIFEST.AboutUsPage}
          tabIndex={0}
          onClick={(e) => onLinkClick(e, { path: PATHS_MANIFEST.AboutUsPage })}
          data-footer-page={'AboutUsPage'}
        >
          About us
        </S.Linker>
      </S.Li>
      <S.Li>
        <S.Linker
          linkType="inverted"
          to={PATHS_MANIFEST.terms}
          tabIndex={0}
          onClick={(e) => onLinkClick(e, { path: PATHS_MANIFEST.terms, isExternalUrl: true })}
          data-footer-page={'termsOfUse'}
        >
          Terms of use
        </S.Linker>
      </S.Li>
      <S.Li>
        <S.Linker
          linkType="inverted"
          to={PATHS_MANIFEST.privacy}
          tabIndex={0}
          onClick={(e) => onLinkClick(e, { isExternalUrl: true })}
          data-footer-page={'privacyNotice'}
        >
          Privacy Notice
        </S.Linker>
      </S.Li>
      <S.Li>
        <S.Linker
          linkType="inverted"
          to={PATHS_MANIFEST.privacyAdChoices}
          tabIndex={0}
          onClick={(e) => onLinkClick(e, { path: PATHS_MANIFEST.privacyAdChoices, isExternalUrl: true })}
          data-footer-page={'adChoices'}
        >
          Ad Choices
        </S.Linker>
      </S.Li>
      <S.Li>
        <S.Linker linkType="inverted" tabIndex={0} onClick={handleCookiePreferencesClick}>
          Cookie Preference
        </S.Linker>
      </S.Li>
      <S.Li>
        <S.Linker
          linkType="inverted"
          to={PATHS_MANIFEST.help}
          tabIndex={0}
          onClick={(e) => onLinkClick(e, { path: PATHS_MANIFEST.help, isExternalUrl: true })}
          data-footer-page={'help'}
        >
          Help
        </S.Linker>
      </S.Li>
      <S.Li>
        <S.Linker
          linkType="inverted"
          to={PATHS_MANIFEST.feedsPage}
          tabIndex={0}
          onClick={(e) => onLinkClick(e, { path: PATHS_MANIFEST.feedsPage, isExternalUrl: true })}
          data-footer-page={'FeedsPage'}
        >
          Feeds
        </S.Linker>
      </S.Li>
      <S.Li>
        <S.Linker
          linkType="inverted"
          to={PATHS_MANIFEST.PostAListingPage}
          tabIndex={0}
          onClick={(e) => onLinkClick(e, { path: PATHS_MANIFEST.PostAListingPage })}
          data-footer-page={'PostAListingPage'}
        >
          List your rental
        </S.Linker>
      </S.Li>
      <S.Li>
        <S.Linker
          linkType="inverted"
          to={PATHS_MANIFEST.SitemapPage}
          tabIndex={0}
          onClick={(e) => onLinkClick(e, { path: PATHS_MANIFEST.SitemapPage })}
          data-footer-page={'SitemapPage'}
        >
          Sitemap
        </S.Linker>
      </S.Li>
      <S.Li>
        <S.Linker linkType="inverted" tabIndex={0} onClick={onModalLinkClick} data-footer-page={'feedback'}>
          Send feedback
        </S.Linker>
      </S.Li>
      <S.Li>
        <S.Linker
          to={PATHS_MANIFEST.zgCcpaCookiePage}
          tabIndex={0}
          onClick={(e) => onLinkClick(e, { path: PATHS_MANIFEST.zgCcpaCookiePage, isExternalUrl: true })}
          data-footer-page={'doNotSellMyInfo'}
        >
          Do Not Sell or Share My Personal Information
        </S.Linker>
      </S.Li>
    </S.FooterList>
  );
};

export default FooterLinks;
